/**
 *
 * @param {object, undefined} user
 */
export function formatUserName(user) {
    let userName = '';

    if (user?.first_name) {
        userName += user.first_name;
    }

    if (user?.last_name) {
        if (userName !== '') {
            userName += ' ';
        }
        userName += user.last_name;
    }

    return userName;
}
